import { CURATED_PRODUCTS_DATA } from 'constants/signup';
import useGlobalStore from 'hooks/useGlobalStore';

export default function ProductPreviewWall() {
    const { isMisfitsTheme } = useGlobalStore();

    return (
        <div className="mx-auto grid max-w-[820px] grid-cols-2 gap-[20px] px-25 pb-30 md:grid-cols-3 lg:grid-cols-4">
            {CURATED_PRODUCTS_DATA.map((content) => (
                <div
                    key={content.id}
                    className="relative mx-auto w-full overflow-hidden rounded-lg bg-white shadow-base"
                    data-optimizely-id={`product-tile-${content.id}`}
                >
                    {isMisfitsTheme ? (
                        // Lime background blob
                        <svg
                            className="absolute"
                            width="78"
                            height="66"
                            viewBox="0 0 78 66"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_2278_21841)">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M22.7501 54.1222C-0.163116 55.3813 -20.0214 36.7008 -21.1593 18.7634C-22.2972 0.825003 0.844448 -11.5633 23.7577 -12.8225C46.6709 -14.0816 63.7687 -8.91632 64.9067 9.02317C66.0447 26.9616 45.6633 52.863 22.7501 54.1222Z"
                                    fill="#D7E1B8"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_2278_21841">
                                    <rect width="78" height="66" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    ) : (
                        // Strawberry background blob
                        <svg
                            className="absolute"
                            width="78"
                            height="66"
                            viewBox="0 0 78 66"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_2278_21840)">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M22.7501 54.1222C-0.163116 55.3813 -20.0214 36.7008 -21.1593 18.7634C-22.2972 0.825003 0.844448 -11.5633 23.7577 -12.8225C46.6709 -14.0816 63.7687 -8.91632 64.9067 9.02317C66.0447 26.9616 45.6633 52.863 22.7501 54.1222Z"
                                    fill="#F0D3E3"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_2278_21840">
                                    <rect width="78" height="66" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    )}
                    <img className="mx-auto w-full rounded-lg" src={content.image} alt={content.name} />
                    <div className="card-content p-10">
                        <p>{content.brand}</p>
                        <p className="font-grotesk-bold">{content.name}</p>
                    </div>
                    <p className="absolute left-[10px] top-[2px] font-grotesk-bold">
                        {content.percent}% <span className="block">OFF</span>
                    </p>
                </div>
            ))}
        </div>
    );
}
